import React, { FC, memo } from 'react'

import { Loader } from '@/components/Loader'
import { RetryButton } from '@/components/RetryButton/RetryButton'
import { focusIds } from '@/constants/focus'

import { LineLoaderElem, LineLoaderWrapper } from './styles'

export const LineLoaderRaw: FC<{
  error?: boolean
  action?: () => void
}> = ({ action, error }) => {
  return (
    <LineLoaderElem
      focusId={focusIds.LINE_LOADER}
      defaultFocusChild={0}
      elementType="div"
    >
      {error ? (
        <RetryButton
          action={() => {
            action && action()
          }}
        />
      ) : (
        <LineLoaderWrapper>
          <Loader />
        </LineLoaderWrapper>
      )}
    </LineLoaderElem>
  )
}

export const LineLoader = memo(LineLoaderRaw)
